import { OwnerPayAppsList } from "@/components/pay-apps/OwnerPayAppsList";

export function OwnerPayAppsPage() {
  return <OwnerPayAppsList />;
}
